import React from 'react';
import './evidence-il.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/free-regular-svg-icons';

const EvidenceIL = ({
	prefillData
}) => {
  
	return (
    <div className='evidence-il'>
			<div className='header-section'>
				<div className='header-left'>
					<img src='https://eval.ilprincipals.org/images/isbe_logo.jpg' alt='ISBE Logo' />
					<div className="g-space-0-5"></div>
					<p className='address'>
						100 North First Street, E-240<br />
						Springfield, Illinois 62777-0001<br />
					</p>
				</div>
				<div className='header-right'>
					<img src='https://eval.ilprincipals.org/images/bar_code.png' alt='barcode' />
					<div className="g-space-0-5"></div>
					<p><b>
						EVIDENCE OF COMPLETION FOR<br />
						PROFESSIONAL DEVELOPMENT
					</b></p>
				</div>
			</div>
			<div className="g-space-0-5"></div>
			<div className='title-bar'>
				<img src='https://eval.ilprincipals.org/images/title_bar.png' alt='Educator Effectiveness Department' />
			</div>
			<div className='form-body page-1'>
				<div className='text-section'>
					<p className='content-paragraph'>
						This is to certify that the individual named below has completed the professional 
						development activity as described herein and that the provider is approved by the 
						state superintendent of education at the time of completion. This form serves as 
						evidence to verify participation in this professional development activity and must 
						be maintained for a period of six years by the licensee and produced if requested as 
						part of an audit.
					</p>
				</div>
				<div className="g-space-0-5"></div>
				<div className='alert-section'>
					<p className='alert-text'>
						IMPORTANT: THE LICENSEE MUST ENTER THE ACTIVITY INTO THE EDUCATOR LICENSURE INFORMATION
						SYSTEM (ELIS) BY AUGUST 31 OF THE LICENSE RENEWAL YEAR. LICENSEES RETAIN THIS FORM FOR 
						SIX YEARS FOR AUDITING PURPOSES. DO NOT SUBMIT THE FORM TO ISBE UNLESS THE AGENCY 
						REQUESTS YOU TO DO SO.
					</p>
				</div>

				<table className='form-table'>

					<tbody>
						<tr>
							<td className='cell-with-label' width='50%'>
								<p className='label-text'>LEGAL NAME OF PARTICIPANT (Last, First, Middle Initial)</p>
								<p className='cell-text'>{prefillData.fName} {prefillData.lName}</p>
							</td>
							<td className='cell-with-label' width='50%'>
								<p className='label-text'>AFFIRMED NAME OF PARTICIPANT (if applicable) (Last, First, Middle Initial)</p>
								<p className='cell-text'></p>
							</td>
						</tr>
						<tr>
							<td className='cell-with-label' width='50%'>
								<p className='label-text'>TITLE OF PROFESSIONAL DEVELOPMENT</p>
								<p className='cell-text'>{prefillData.title}</p>
							</td>
							<td className='cell-with-label' width='50%'>
								<p className='label-text'>IEIN</p>
								<p className='cell-text'>{prefillData.iein}</p>
							</td>
						</tr>
						<tr>
							<td className='cell-with-label' colSpan='2' >
								<p className='label-text'>DATE(S) OF ACTIVITY</p>
								<p className='cell-text'>{prefillData.startDate} - {prefillData.endDate}</p>
							</td>
						</tr>
						<tr>
							<td className='cell-with-label' width='50%'>
								<p className='label-text'>NAME OF APPROVED PROVIDER (Enter in ELIS)</p>
								<p className='cell-text'>Illinois Principals Association</p>
							</td>
							<td className='cell-with-label' width='50%'>
								<p className='label-text'>REGION, COUNTY, DISTRICT, TYPE (RCDT) CODE (Form is invalid without a state-approved provider RCDT code)</p>
								<p className='cell-text short'>651080180510000</p>
							</td>
						</tr>
						<tr>
							<td className='cell-with-label' colSpan='2' >
								<p className='label-text'>NAME OF THIRD-PARTY PRESENTER/ORGANIZATION AUTHORIZED 
									BY A STATE-APPROVED PROVIDER ABOVE (if used)
								</p>
								<p className='cell-text'></p>
							</td>
						</tr>
						<tr>
							<td className='cell-with-label' colSpan='2' >
								<p className='label-text'>NAME OF PRESENTER(S) (Do not enter into ELIS)
								</p>
								<p className='cell-text'>{prefillData.pres}</p>
							</td>
						</tr>
						<tr>
							<td className='cell-with-label' colSpan='2' >
								<p className='label-text'>NUMBER OF PROFESSIONAL DEVELOPMENT HOURS AWARDED
								</p>
								<p className='cell-text'>{prefillData.hours}</p>
							</td>
						</tr>
					</tbody>
				</table>
				<div className="g-space-0-5"></div>
				<div className='mandated-section'>
					<p className='mandated-checkbox'>
						IS THIS ACTIVITY A STATE-MANDATED TRAINING? <FontAwesomeIcon icon={faSquare} size="sm" /> YES <FontAwesomeIcon icon={faSquare} size="sm" /> NO
					</p>
					<p className='mandated-text'>
						If you answered "yes," place a check mark next to the corresponding 
						training listed on the chart below.
					</p>
				</div>
				
				<div className="g-space-1-5"></div>

				<div className='mandated-checklist'>
					<h4>State-Mandated Training Checklist</h4>
					<div className='checklist-grid'>
						<div className='left-column'>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Anaphylactic Reactions & Mgmt.
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Asbestos Mgmt. & Abatement
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Asthma Management
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Automated External Defibrilator
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Bloodborne Pathogens
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Bullying Prevention *
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Care of Students with Diabetes
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Concussions & Head Injuries
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Cultural Competency
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Educator Ethics
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Educator Evaluator
							</p>
							<div className="g-space-0-5"></div>
							<p className='optional'>* Optional Training</p>
						</div>
						<div className='right-column'>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Educator Evaluator (Board)
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Ensuring Success in Schools
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								First Aid, Heimlich, & CPR
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Freedom of Information Act (FOIA)
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Hazardous Materials Training
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Health Conditions of Students
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Health Conditions of Students (Life-Threatening Bleeding)
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Identity Protection
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Isolated Time Out/Restraint
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} />
								Mandated Reporting of Child Abuse & Neglect
							</p>
						</div>
					</div>	
				</div>

				<div className='footer-section'>
					<p className='continued'>
						CONTINUED NEXT PAGE
					</p>
					<hr />
					<p className='footer-text'>
						<span>ISBE 77-21B (7/24)</span>
						<span>PAGE 1 OF 2</span>
					</p>
				</div>
			</div>
			<div className='break'></div>
			<div className='form-body page-2'>
				<div className='mandated-checklist'>
					<h4>State-Mandated Training Checklist <i>(continued)</i></h4>
					<div className='checklist-grid'>
						<div className='left-column'>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Mental Illness, Trauma & Suicide
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Non-Restaurant Food Handler
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Nutrition Training (Civil Rights)
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Nutrition Training (General)
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Open Meetings Act (Board)
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Open Meetings Act (Other)
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Opioid Overdose
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Pest Management Plan
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Preventing and Responding to Child Sexual Abuse
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Protections and Accommodations for Students (ADA)
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Protections and Accommodations for Students (Homelessness)
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Racism-Free Schools
							</p>
							<div className="g-space-0-5"></div>
							<p className='optional'>* Optional Training</p>
						</div>
						<div className='left-column'>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								School Board Membership Leadership
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								School Bus Driver Training
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								School Student Records Act *
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Sexual Harassment & Discrimination
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Short-Term Sub Teacher Training
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Social-Emotional Learning
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								SpEd Training for Personnel w/o License
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								SpEd Training for Qualified Interpreters
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Student Discipline *
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Title IX
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Trauma-Informed Practices
							</p>
							<p className='checklist-item'>
								<FontAwesomeIcon icon={faSquare} /> 
								Violence Prevention & Conflict Resolution *
							</p>
						</div>
					</div>
				</div>
				
				<div className="g-space-2"></div>
				<div className="g-space-2"></div>
				<div className='signatures-section'>
					<div className='signatures-grid'>
						<div className='signature-block'>
							<div className='blank-space'>
								<img 
									src="https://eval.ilprincipals.org/images/sign_homes.png" 
									className="signature-image"
									alt="signature" />
							</div>
							<hr />
							<p className='signature-label'>Signature of Approved Provider's Representative</p>
						</div>
						<div className='signature-block'>
							<div className='blank-space'>{prefillData.endDate}</div>
							<hr />
							<p className='signature-label'>Date</p>
						</div>
					</div>
					<div className="g-space-1"></div>
					<div className='signatures-grid'>
						<div className='signature-block'>
							<div className='blank-space'></div>
							<hr />
							<p className='signature-label'>Signature of Participant's Legal Name</p>
						</div>
						<div className='signature-block'>
							<div className='blank-space'></div>
							<hr />
							<p className='signature-label'>Date</p>
						</div>
					</div>
					<div className="g-space-1"></div>
					<div className='signatures-grid'>
						<div className='signature-block'>
							<div className='blank-space'></div>
							<hr />
							<p className='signature-label'>Signature of Participant's Affirmed Name (if applicable)</p>
						</div>
						<div className='signature-block'>
							<div className='blank-space'></div>
							<hr />
							<p className='signature-label'>Date</p>
						</div>
					</div>
				</div>
				<div className="spacer"></div>
				<div className='footer-section'>
					<p className='continued'>
						CONTINUED NEXT PAGE
					</p>
					<hr />
					<p className='footer-text'>
						<span>ISBE 77-21B (7/24)</span>
						<span>PAGE 1 OF 2</span>
					</p>
				</div>
			</div>
    </div>
  )
}

export default EvidenceIL